import { Notification, Typography } from "@drone-js/core";
import { Fragment } from "react";
import { DropdownField } from "../../form/DropdownField";
import { useMetadataAtomValue } from "../../metadataAtom";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { NightlyRateController } from "./NightlyRateController";

export const ChannelManagerPriceController = () => {
    const {
        cmsData: {
            pricing: {
                minimumNightlyRate,
                howToSetUpYourChannelManager,
                instructionsForSettingUpYourChannelManager,
                channelManager,
                pleaseSelectAChannelManagerToContinue,
                channelManagerSetup,
            },
        },
    } = useStaticDataAtomValue();
    const { channelManagers: cmList } = useMetadataAtomValue();

    return (
        <Fragment>
            <Typography variant="body-default-strong">{channelManagerSetup}</Typography>
            <DropdownField
                label={channelManager}
                field="channelManager"
                items={cmList ?? []}
                identifyBy="userId"
                rules={{
                    required: pleaseSelectAChannelManagerToContinue,
                }}
                dataElementName="channel-manager-dropdown"
            />
            <NightlyRateController label={minimumNightlyRate} dataElementName="minimum-nightly-rate" />
            <Notification
                intent="notice"
                title={howToSetUpYourChannelManager}
                description={instructionsForSettingUpYourChannelManager}
                asset={{
                    id: "fill.symbol.circle-info",
                }}
            />
        </Fragment>
    );
};
